export default __webpack_public_path__ + "53d000b7dbb0f70348aaa066f865b71d.png";